module.exports = __webpack_public_path__ + "static/img/Bitmap.a61e157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner/Bitmap.png
// module id = /oTF
// module chunks = 1